export default function getCommonLinks(product: AnimatronProduct) {
    switch (product) {
        case 'WAVE':
            return {
                pricing: '/pricing',
                facebook: '//www.facebook.com/wave.video',
                twitter: '//twitter.com/wave_video',
                instagram: '//www.instagram.com/wave.video/',
                youtube: 'https://www.youtube.com/wavevideo'
            };

        case 'STUDIO':
        default:
            return {
                pricing: '/studio/pricing',
                facebook: '//www.facebook.com/TheAnimatron',
                github: '//github.com/Animatron',
                twitter: '//twitter.com/animatron',
                youtube: '//www.youtube.com/c/AnimatronHero'
            }
    }
}


// WEBPACK FOOTER //
// ./app/assets/javascripts/routes/commonLinks.ts